import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { totalCallsSelector } from '../selectors/dashboardSelector';
import { getTotalCallsRequest } from '../actions/dashboardActions';
import CriticalInformation from '../components/CriticalInformation/CriticalInformation';

const mapStateToProps = createStructuredSelector({ data: totalCallsSelector });
const mapDispatchToProps = { getData: getTotalCallsRequest };

export default connect(mapStateToProps, mapDispatchToProps)(CriticalInformation);
